<template>
  <div style="display: flex; align-items: center">
    <svg
      v-if="name === 'ai-close-icon'"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.55566 2.55469L11.4446 11.4436"
        stroke="#A2A9B6"
        stroke-width="1.2"
      />
      <path
        d="M11.4443 2.55469L2.55545 11.4436"
        stroke="#A2A9B6"
        stroke-width="1.2"
      />
    </svg>
    <!-- 机器人 -->
    <svg
      v-if="name === 'robotIcon1'"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_42586_37463)" />
      <g filter="url(#filter0_i_42586_37463)">
        <circle
          cx="25.1061"
          cy="24.8942"
          r="12.8942"
          fill="url(#paint1_linear_42586_37463)"
        />
      </g>
      <rect
        x="24.1904"
        y="19.4844"
        width="2.76923"
        height="6.40385"
        rx="1.38462"
        fill="url(#paint2_linear_42586_37463)"
      />
      <rect
        x="31.4229"
        y="20.3477"
        width="2.25"
        height="4.5"
        rx="1.125"
        fill="url(#paint3_linear_42586_37463)"
      />
      <path
        d="M15 20.6602H17.19C19.2942 20.6602 21 22.366 21 24.4702C21 26.5744 19.2942 28.2802 17.19 28.2802H15V20.6602Z"
        fill="url(#paint4_linear_42586_37463)"
      />
      <ellipse
        cx="14.9811"
        cy="24.46"
        rx="3.46154"
        ry="3.80769"
        fill="url(#paint5_linear_42586_37463)"
      />
      <ellipse
        cx="13.5096"
        cy="24.4606"
        rx="2.50962"
        ry="2.76923"
        fill="url(#paint6_linear_42586_37463)"
      />
      <path
        d="M25.4014 29.2734C26.3304 30.1212 29.1848 31.831 32.6174 29.5094C31.9782 31.6615 27.911 34.4519 25.4014 29.2734Z"
        fill="url(#paint7_linear_42586_37463)"
      />
      <defs>
        <filter
          id="filter0_i_42586_37463"
          x="12.2119"
          y="9.83593"
          width="26.5099"
          height="27.9531"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.721356" dy="-2.16407" />
          <feGaussianBlur stdDeviation="1.80339" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.621878 0 0 0 0 0.756897 0 0 0 0 0.920342 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37463"
          />
        </filter>
        <linearGradient
          id="paint0_linear_42586_37463"
          x1="40.5"
          y1="45"
          x2="7.5"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00480769" stop-color="#84E2F4" />
          <stop offset="0.567308" stop-color="#649FF6" />
          <stop offset="1" stop-color="#8C82F9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_42586_37463"
          x1="25.1061"
          y1="12"
          x2="25.1061"
          y2="37.7885"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E6FAFF" />
          <stop offset="1" stop-color="#E6E5FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_42586_37463"
          x1="25.575"
          y1="19.4844"
          x2="25.575"
          y2="25.8882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8686F9" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_42586_37463"
          x1="32.5479"
          y1="20.3477"
          x2="32.5479"
          y2="24.8477"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8885F9" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_42586_37463"
          x1="17.5"
          y1="20.6602"
          x2="17.5"
          y2="28.2802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DAF5F9" />
          <stop offset="1" stop-color="#9DA3FC" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_42586_37463"
          x1="14.9811"
          y1="20.6523"
          x2="14.9811"
          y2="28.2677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#68B8FD" />
          <stop offset="1" stop-color="#4141EF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_42586_37463"
          x1="13.5096"
          y1="21.6914"
          x2="13.5096"
          y2="27.2299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83D2FF" />
          <stop offset="1" stop-color="#7094FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_42586_37463"
          x1="28.9453"
          y1="28.6175"
          x2="29.6264"
          y2="32.1177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8587F8" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-if="name === 'bigRobotIcon'"
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23"
        cy="23"
        r="23"
        fill="url(#paint0_linear_42586_37354)"
        fill-opacity="0.8"
      />
      <g filter="url(#filter0_i_42586_37354)">
        <circle
          cx="23.1453"
          cy="22.8587"
          r="17.4993"
          fill="url(#paint1_linear_42586_37354)"
        />
      </g>
      <rect
        x="21.9023"
        y="15.5117"
        width="3.75824"
        height="8.69094"
        rx="1.87912"
        fill="url(#paint2_linear_42586_37354)"
      />
      <rect
        x="31.7178"
        y="16.6836"
        width="3.05357"
        height="6.10714"
        rx="1.52679"
        fill="url(#paint3_linear_42586_37354)"
      />
      <path
        d="M9.43018 17.1133H12.4023C15.258 17.1133 17.573 19.4283 17.573 22.284C17.573 25.1397 15.258 27.4547 12.4023 27.4547H9.43018V17.1133Z"
        fill="url(#paint4_linear_42586_37354)"
      />
      <ellipse
        cx="9.40288"
        cy="22.2574"
        rx="4.6978"
        ry="5.16758"
        fill="url(#paint5_linear_42586_37354)"
      />
      <ellipse
        cx="7.40591"
        cy="22.2778"
        rx="3.40591"
        ry="3.75824"
        fill="url(#paint6_linear_42586_37354)"
      />
      <path
        d="M23.5435 28.7969C24.8043 29.9474 28.6781 32.2679 33.3366 29.1171C32.4692 32.0378 26.9494 35.8248 23.5435 28.7969Z"
        fill="url(#paint7_linear_42586_37354)"
      />
      <defs>
        <filter
          id="filter0_i_42586_37354"
          x="5.646"
          y="2.42243"
          width="35.9775"
          height="37.9369"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.978983" dy="-2.93695" />
          <feGaussianBlur stdDeviation="2.44746" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.621878 0 0 0 0 0.756897 0 0 0 0 0.920342 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37354"
          />
        </filter>
        <linearGradient
          id="paint0_linear_42586_37354"
          x1="37.26"
          y1="41.4"
          x2="6.9"
          y2="5.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00480771" stop-color="#84E2F4" />
          <stop offset="0.567308" stop-color="#649FF6" />
          <stop offset="1" stop-color="#8C82F9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_42586_37354"
          x1="23.1453"
          y1="5.35937"
          x2="23.1453"
          y2="40.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E6FAFF" />
          <stop offset="1" stop-color="#E6E5FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_42586_37354"
          x1="23.7815"
          y1="15.5117"
          x2="23.7815"
          y2="24.2027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8686F9" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_42586_37354"
          x1="33.2446"
          y1="16.6836"
          x2="33.2446"
          y2="22.7907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8885F9" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_42586_37354"
          x1="12.823"
          y1="17.1133"
          x2="12.823"
          y2="27.4547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DAF5F9" />
          <stop offset="1" stop-color="#9DA3FC" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_42586_37354"
          x1="9.40288"
          y1="17.0898"
          x2="9.40288"
          y2="27.425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#68B8FD" />
          <stop offset="1" stop-color="#4141EF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_42586_37354"
          x1="7.40591"
          y1="18.5195"
          x2="7.40591"
          y2="26.036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#83D2FF" />
          <stop offset="1" stop-color="#7094FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_42586_37354"
          x1="28.3531"
          y1="27.9067"
          x2="29.2775"
          y2="32.657"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8587F8" />
          <stop offset="1" stop-color="#72B5FF" />
        </linearGradient>
      </defs>
    </svg>

    <!-- 靠右 -->
    <svg
      v-if="name === 'rightIcon'"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_42586_37410)">
        <path
          d="M10 11.5C10 10.6716 10.6716 10 11.5 10H26.5C27.3285 10 28 10.6716 28 11.5V26.5C28 27.3285 27.3285 28 26.5 28H11.5C10.6716 28 10 27.3285 10 26.5V11.5Z"
          stroke="white"
          stroke-width="1.6"
        />
        <path d="M23 10V28" stroke="white" stroke-width="1.6" />
        <path d="M15 17L17 19L15 21" stroke="white" stroke-width="1.6" />
        <path d="M20 10H26" stroke="white" stroke-width="1.6" />
        <path d="M20 28H26" stroke="white" stroke-width="1.6" />
      </g>
      <defs>
        <filter
          id="filter0_i_42586_37410"
          x="0"
          y="0"
          width="38"
          height="39"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37410"
          />
        </filter>
      </defs>
    </svg>
    <!-- 靠左 -->
    <svg
      v-if="name === 'leftIcon'"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_42586_37402)">
        <path
          d="M10 11.5C10 10.6716 10.6716 10 11.5 10H26.5C27.3285 10 28 10.6716 28 11.5V26.5C28 27.3285 27.3285 28 26.5 28H11.5C10.6716 28 10 27.3285 10 26.5V11.5Z"
          stroke="white"
          stroke-width="1.6"
        />
        <path d="M15 10V28" stroke="white" stroke-width="1.6" />
        <path d="M23 17L21 19L23 21" stroke="white" stroke-width="1.6" />
        <path d="M20 10H26" stroke="white" stroke-width="1.6" />
        <path d="M20 28H26" stroke="white" stroke-width="1.6" />
      </g>
      <defs>
        <filter
          id="filter0_i_42586_37402"
          x="0"
          y="0"
          width="38"
          height="39"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37402"
          />
        </filter>
      </defs>
    </svg>
    <svg
      v-if="name === 'closeIcon'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42586_37419)">
        <path
          d="M5 5L19 19"
          stroke="white"
          stroke-width="1.6"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M5 19L19 5"
          stroke="white"
          stroke-width="1.6"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_42586_37419">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'sendIcon'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7324 1.44523C16.1989 1.26891 16.6638 1.71673 16.585 2.26641L14.622 15.9714C14.6051 16.0892 14.5634 16.2007 14.5003 16.2963C14.4372 16.3919 14.3547 16.4688 14.2597 16.5206C14.1647 16.5723 14.0601 16.5973 13.9547 16.5934C13.8493 16.5894 13.7464 16.5568 13.6546 16.4981L8.42918 13.1608L5.74489 14.7342C5.649 14.7807 5.54468 14.8006 5.44064 14.7921C5.3366 14.7837 5.23585 14.7472 5.14679 14.6858C5.05773 14.6243 4.98293 14.5396 4.92865 14.4387C4.87437 14.3379 4.84216 14.2238 4.83473 14.106L4.83309 14.052L5.14679 11.0643L0.895342 8.34922C0.417361 8.04363 0.467744 7.25726 0.959466 7.0228L1.01018 7.00131L15.7324 1.44523ZM15.1199 3.23762L2.82231 7.8788L6.12336 9.98678C6.21649 10.0463 6.29531 10.1308 6.35291 10.2328C6.41052 10.3349 6.44516 10.4513 6.45379 10.572L6.45608 10.6335L6.14337 12.9293L8.21162 11.6547C8.29465 11.6145 8.38414 11.5941 8.47445 11.595C8.56476 11.5958 8.65395 11.6178 8.73639 11.6595L8.7907 11.6906L13.4802 14.6858L15.1199 3.23762ZM13.1701 5.37782C13.2752 5.52065 13.329 5.70299 13.3209 5.88867C13.3128 6.07434 13.2433 6.24977 13.1262 6.38014L13.0863 6.42089L9.16039 10.1249C9.03055 10.2463 8.8644 10.3063 8.69648 10.2925C8.52857 10.2787 8.37181 10.1922 8.25881 10.0509C8.1458 9.90958 8.08525 9.72441 8.08975 9.53386C8.09424 9.34332 8.16344 9.16207 8.28294 9.0278L8.32286 8.98706L12.2488 5.283C12.3821 5.15731 12.554 5.09669 12.7268 5.11447C12.8995 5.13226 13.059 5.22698 13.1701 5.37782Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name === 'knowledgeIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33301 12.3346C2.33301 9.76687 2.33301 3.66797 2.33301 3.66797C2.33301 2.5634 3.22844 1.66797 4.33301 1.66797H11.6663V10.3346C11.6663 10.3346 6.07721 10.3346 4.33301 10.3346C3.23301 10.3346 2.33301 11.2294 2.33301 12.3346Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M11.6663 10.332C11.6663 10.332 4.71757 10.332 4.33301 10.332C3.22844 10.332 2.33301 11.2275 2.33301 12.332C2.33301 13.4366 3.22844 14.332 4.33301 14.332C5.06937 14.332 8.62494 14.332 13.6663 14.332V2.33203"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path d="M4.66699 12.332H11.3337" stroke="#0D0E0F" stroke-width="1.2" />
    </svg>
    <svg
      v-if="name === 'assessmentIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99997 8V4M7.99997 8L4.5 10.0207M7.99997 8L11.4999 10.0207"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M4.66667 5.33333C4.66667 6.0697 4.0697 6.66667 3.33333 6.66667C2.59695 6.66667 2 6.0697 2 5.33333C2 4.59697 2.59695 4 3.33333 4C4.0697 4 4.66667 4.59697 4.66667 5.33333Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M4.66667 10.6654C4.66667 11.4017 4.0697 11.9987 3.33333 11.9987C2.59695 11.9987 2 11.4017 2 10.6654C2 9.929 2.59695 9.33203 3.33333 9.33203C4.0697 9.33203 4.66667 9.929 4.66667 10.6654Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M9.33366 13.3333C9.33366 14.0697 8.73669 14.6667 8.00033 14.6667C7.26396 14.6667 6.66699 14.0697 6.66699 13.3333C6.66699 12.597 7.26396 12 8.00033 12C8.73669 12 9.33366 12.597 9.33366 13.3333Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M13.9997 10.6654C13.9997 11.4017 13.4027 11.9987 12.6663 11.9987C11.93 11.9987 11.333 11.4017 11.333 10.6654C11.333 9.929 11.93 9.33203 12.6663 9.33203C13.4027 9.33203 13.9997 9.929 13.9997 10.6654Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M13.9997 5.33333C13.9997 6.0697 13.4027 6.66667 12.6663 6.66667C11.93 6.66667 11.333 6.0697 11.333 5.33333C11.333 4.59697 11.93 4 12.6663 4C13.4027 4 13.9997 4.59697 13.9997 5.33333Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
      <path
        d="M9.33366 2.66536C9.33366 3.40173 8.73669 3.9987 8.00033 3.9987C7.26396 3.9987 6.66699 3.40173 6.66699 2.66536C6.66699 1.92898 7.26396 1.33203 8.00033 1.33203C8.73669 1.33203 9.33366 1.92898 9.33366 2.66536Z"
        stroke="#0D0E0F"
        stroke-width="1.2"
      />
    </svg>
    <svg
      v-if="name === 'historicalIcon'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke="#0D0E0F"
        stroke-width="1.4"
      />
      <path
        d="M9.00289 4.5L9.00244 9.0033L12.1822 12.1831"
        stroke="#0D0E0F"
        stroke-width="1.4"
      />
    </svg>
    <svg
      v-if="name === 'stopIcon'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="10"
        height="10"
        rx="1"
        fill="white"
        stroke="white"
        stroke-width="1.2"
      />
    </svg>
    <svg
      v-if="name === 'loadingIcon'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="loading-spinner"
    >
      <circle cx="9" cy="9" r="7" stroke="#E6E6E6" stroke-width="2" />
      <path
        d="M9 2C13.4183 2 17 5.58172 17 10"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'analysis-btn-icon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28011 11.9909L5.96494 10.1595C5.53246 10.6288 4.97064 10.9553 4.35253 11.0967C3.73442 11.238 3.08863 11.1877 2.49914 10.9522C1.90965 10.7167 1.40374 10.3069 1.0472 9.77619C0.690667 9.24545 0.5 8.6183 0.5 7.97629C0.5 7.33428 0.690667 6.70713 1.0472 6.17639C1.40374 5.64565 1.90965 5.23588 2.49914 5.00038C3.08863 4.76488 3.73442 4.71454 4.35253 4.85591C4.97064 4.99727 5.53246 5.32381 5.96494 5.79304L9.28011 3.99366C9.21328 3.7326 9.18142 3.46361 9.18539 3.19394C9.18653 2.44955 9.44386 1.72887 9.91306 1.15604C10.3823 0.583213 11.0339 0.194106 11.7558 0.0557474C12.4778 -0.0826109 13.2247 0.0384429 13.868 0.398056C14.5113 0.757669 15.0106 1.33332 15.2801 2.02586C15.5495 2.71839 15.5721 3.48444 15.344 4.19205C15.1159 4.89965 14.6513 5.50451 14.0304 5.90242C13.4095 6.30033 12.671 6.46638 11.9422 6.37196C11.2135 6.27755 10.54 5.92859 10.0379 5.38518L6.72269 7.19256C6.78905 7.45371 6.82091 7.72264 6.81741 7.99228C6.81909 8.26234 6.78457 8.53137 6.7148 8.79201L10.03 10.6234C10.5309 10.0773 11.2044 9.72558 11.9341 9.6291C12.6638 9.53262 13.4038 9.69739 14.0263 10.095C14.6488 10.4925 15.1147 11.0979 15.3435 11.8065C15.5723 12.5151 15.5496 13.2824 15.2794 13.9759C15.0091 14.6693 14.5083 15.2454 13.8634 15.6045C13.2185 15.9636 12.4701 16.0832 11.7475 15.9426C11.0248 15.8021 10.3733 15.4102 9.90548 14.8347C9.43768 14.2592 9.18298 13.5362 9.18539 12.7906C9.18301 12.5205 9.21754 12.2514 9.288 11.9909H9.28011ZM3.6601 9.59173C4.07879 9.59173 4.48032 9.42322 4.77638 9.12326C5.07243 8.82331 5.23876 8.41648 5.23876 7.99228C5.23876 7.56808 5.07243 7.16126 4.77638 6.8613C4.48032 6.56135 4.07879 6.39284 3.6601 6.39284C3.24142 6.39284 2.83988 6.56135 2.54383 6.8613C2.24777 7.16126 2.08145 7.56808 2.08145 7.99228C2.08145 8.41648 2.24777 8.82331 2.54383 9.12326C2.83988 9.42322 3.24142 9.59173 3.6601 9.59173ZM12.3427 4.79339C12.7614 4.79339 13.1629 4.62487 13.459 4.32492C13.755 4.02496 13.9214 3.61814 13.9214 3.19394C13.9214 2.76974 13.755 2.36291 13.459 2.06296C13.1629 1.763 12.7614 1.59449 12.3427 1.59449C11.924 1.59449 11.5225 1.763 11.2264 2.06296C10.9304 2.36291 10.764 2.76974 10.764 3.19394C10.764 3.61814 10.9304 4.02496 11.2264 4.32492C11.5225 4.62487 11.924 4.79339 12.3427 4.79339ZM12.3427 14.3901C12.7614 14.3901 13.1629 14.2216 13.459 13.9216C13.755 13.6217 13.9214 13.2148 13.9214 12.7906C13.9214 12.3664 13.755 11.9596 13.459 11.6596C13.1629 11.3597 12.7614 11.1912 12.3427 11.1912C11.924 11.1912 11.5225 11.3597 11.2264 11.6596C10.9304 11.9596 10.764 12.3664 10.764 12.7906C10.764 13.2148 10.9304 13.6217 11.2264 13.9216C11.5225 14.2216 11.924 14.3901 12.3427 14.3901Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name === 'retractIcon'"
      :width="graywidth ? graywidth : '38'"
      :height="graywidth ? graywidth : '38'"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_42586_37402)">
        <path
          d="M10 11.5C10 10.6716 10.6716 10 11.5 10H26.5C27.3285 10 28 10.6716 28 11.5V26.5C28 27.3285 27.3285 28 26.5 28H11.5C10.6716 28 10 27.3285 10 26.5V11.5Z"
          stroke="#87909F"
          stroke-width="1.6"
        />
        <path d="M15 10V28" stroke="#87909F" stroke-width="1.6" />
        <path d="M23 17L21 19L23 21" stroke="#87909F" stroke-width="1.6" />
        <path d="M20 10H26" stroke="#87909F" stroke-width="1.6" />
        <path d="M20 28H26" stroke="#87909F" stroke-width="1.6" />
      </g>
      <defs>
        <filter
          id="filter0_i_42586_37402"
          x="0"
          y="0"
          width="38"
          height="39"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37402"
          />
        </filter>
      </defs>
    </svg>

    <svg
      v-if="name === 'expandIcon'"
      :width="graywidth ? graywidth : '38'"
      :height="graywidth ? graywidth : '38'"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_42586_37410)">
        <path
          d="M10 11.5C10 10.6716 10.6716 10 11.5 10H26.5C27.3285 10 28 10.6716 28 11.5V26.5C28 27.3285 27.3285 28 26.5 28H11.5C10.6716 28 10 27.3285 10 26.5V11.5Z"
          stroke="#87909F"
          stroke-width="1.6"
        />
        <path d="M23 10V28" stroke="#87909F" stroke-width="1.6" />
        <path d="M15 17L17 19L15 21" stroke="#87909F" stroke-width="1.6" />
        <path d="M20 10H26" stroke="#87909F" stroke-width="1.6" />
        <path d="M20 28H26" stroke="#87909F" stroke-width="1.6" />
      </g>
      <defs>
        <filter
          id="filter0_i_42586_37410"
          x="0"
          y="0"
          width="38"
          height="39"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_42586_37410"
          />
        </filter>
      </defs>
    </svg>
    <svg
      v-if="name === 'emptyIcon'"
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.6104 49C83.5996 69.7665 66.0988 86 44.8047 86C23.5106 86 6.00976 69.7665 3.99902 49H14.0605C16.0227 64.2314 29.0393 76 44.8047 76C60.5701 76 73.5866 64.2314 75.5488 49H85.6104ZM44.8047 4C66.0988 4 83.5996 20.2335 85.6104 41H75.5488C73.5866 25.7686 60.5701 14 44.8047 14C29.0393 14 16.0227 25.7686 14.0605 41H3.99902C6.00976 20.2335 23.5106 4 44.8047 4Z"
        fill="#D6DBE2"
      />
      <rect x="40" y="44" width="10" height="19" fill="#D6DBE2" />
      <rect x="40" y="28" width="10" height="10" fill="#D6DBE2" />
    </svg>
    <svg
      v-if="name === 'addSessionIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6668 7.9987C14.6668 11.6806 11.6821 14.6654 8.00018 14.6654C6.00901 14.6654 1.3335 14.6654 1.3335 14.6654C1.3335 14.6654 1.3335 9.68943 1.3335 7.9987C1.3335 4.3168 4.31828 1.33203 8.00018 1.33203C11.6821 1.33203 14.6668 4.3168 14.6668 7.9987Z"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M8 5.33203L8 10.6654"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M5.3335 8L10.6668 8"
        stroke="#05ABFA"
        stroke-width="1.2"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name === 'moreIcon'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33366 13.6654C6.25413 13.6654 7.00033 12.9192 7.00033 11.9987C7.00033 11.0782 6.25413 10.332 5.33366 10.332C4.41318 10.332 3.66699 11.0782 3.66699 11.9987C3.66699 12.9192 4.41318 13.6654 5.33366 13.6654Z"
        fill="#87909F"
      />
      <path
        d="M11.9997 13.6654C12.9201 13.6654 13.6663 12.9192 13.6663 11.9987C13.6663 11.0782 12.9201 10.332 11.9997 10.332C11.0792 10.332 10.333 11.0782 10.333 11.9987C10.333 12.9192 11.0792 13.6654 11.9997 13.6654Z"
        fill="#87909F"
      />
      <path
        d="M18.6667 13.6654C19.5871 13.6654 20.3333 12.9192 20.3333 11.9987C20.3333 11.0782 19.5871 10.332 18.6667 10.332C17.7462 10.332 17 11.0782 17 11.9987C17 12.9192 17.7462 13.6654 18.6667 13.6654Z"
        fill="#87909F"
      />
    </svg>
    <svg
      v-if="name === 'deleteIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42620_37254)">
        <path
          d="M3 3.33594V14.6693H13V3.33594H3Z"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linejoin="round"
        />
        <path
          d="M6.66699 6.66406V10.9974"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M9.33301 6.66406V10.9974"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M1.33301 3.33594H14.6663"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.33301 3.33594L6.42934 1.33594H9.59204L10.6663 3.33594H5.33301Z"
          stroke="#0D0E0F"
          stroke-width="1.2"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_42620_37254">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'editIcon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2429 2.87974L7.6731 8.46616L7.50047 8.29353L13.071 2.7078L13.2429 2.87974Z"
        fill="#0D0E0F"
        stroke="#0D0E0F"
      />
      <path
        d="M6.33333 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V9.66667"
        stroke="#0D0E0F"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "aicanvasIcons",
  props: {
    name: {
      type: String,
      required: true,
    },
    graywidth: {
      type: String,
    },
  },
};
</script>
<style lang="less" scoped></style>
